<template>
  <div class="full-height">
    <div :class="{
      simpleButtons: rowButtons,
      crudButtons: !rowButtons,
      cleanLayout: cleanLayout
    }" class="row container q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              {{ $gettext("APPROVALS") }}
            </div>
          </q-card-section>

          <q-card-section class="tw-justify-center">
            <analyze-invoice-settlement-table-header
              :api-response="data"
            ></analyze-invoice-settlement-table-header>
          </q-card-section>
          <q-card-section>
            <div class="tw-mt-6 tw-flex tw-space-x-4">
              <button-filter
                v-for="settlementTypeName in displayedSettlementType"
                :key="settlementTypeName"
                :text="settlementType[settlementTypeName].text"
                :color="settlementType[settlementTypeName].color"
                @clickAction="filterInvoice(settlementTypeName)"/>

              <div class="tw-flex-grow"></div>
              <q-btn :disabled="!isAnyItemSelected"
                     @click="showRejectModal = true"
                     class="reproval tw-px-4 tw-py-2tw-text-gray-600 tw-flex tw-items-center tw-space-x-2 tw-text-sm">
                <span><q-icon name="mdi-close" size="24px" /> {{ $gettext("REJECT") }}</span>
              </q-btn>
              <q-btn :disabled="!isAnyItemSelected"
                     @click="showApprovalModal = true"
                     class="approval tw-px-4 tw-py-2tw-text-gray-600 tw-flex tw-items-center tw-space-x-2 tw-text-sm">
                <span><q-icon name="mdi-check" size="24px" /> {{ $gettext("APPROVE") }}</span>
              </q-btn>
              <q-btn class="filter tw-px-4 tw-py-2 tw-text-gray-600 tw-flex tw-items-center tw-space-x-2 tw-text-sm"
                     flat @click="openModalFilter">
                <q-icon name="filter_list" size="20px" />
                <div class="text-center">{{ $gettext("FILTER") }}</div>
              </q-btn>
            </div>
          </q-card-section>

          <q-card-section class="q-pb-lg card-tab">
            <jt-data-table
              ref="datatable"
              v-if="datatable && data"
              :api-mode="false"
              :data="data"
              :buttons="datatable.buttons"
              :fields="datatable.columns"
              :extra-params="searchParams"
              noneselect
              :is-paginated="true"
              @action-button="datatable.actionButton"
            >

              <template #header="{ props }">
                <q-tr :props="props" class="table-header">
                  <q-td v-if="!noneselect && !rowButtons" auto-width>
                  </q-td>
                  <q-td v-for="col in props.cols"
                        :key="col.name"
                        :props="props"
                        class="text-center"
                  >
                    {{ col.label }}
                  </q-td>
                  <q-td class="width-5 text-center"> </q-td>
                </q-tr>
              </template>

              <template #body="{props}">
                <q-tr class="text-left">
                  <q-td v-if="!noneselect && !rowButtons" auto-width>
                    <q-checkbox
                      v-model="props.row.selected"
                      @input="(status) => {updateSelection(props.row, status)}"
                      color="primary"
                      :data-testid="props.key"
                      :id="props.row.id"
                      :dense="true"
                    />
                  </q-td>
                  <q-td v-for="col in props.cols" :key="col.name" :props="props" class="color-gray">
                    <span v-if="col.field == 'id'">
                      <strong style="font-size: 16px">
                        {{ props.row['id'] }}
                      </strong>
                    </span>
                    <span v-else-if="col.field =='invoiceSettlementHistory_attendant_nmLogin'">
                      {{ props.row['invoiceSettlementHistory_attendant_nmLogin'] }}
                    </span>

                    <span v-else-if="col.field == 'date'">
                      {{ props.row['date'] }}
                    </span>

                    <span v-else-if="col.field == 'invoiceSettlementType'">
                      <button-filter :text="getSettlementTypeByCode(props.row['invoiceSettlementType']).text"
                                     :color="getSettlementTypeByCode(props.row['invoiceSettlementType']).color"

                      />
                    </span>
                    <span v-else-if="col.field == 'invoiceSettlementStatus'" class="text-black">
                      <button-filter :text="getSettlementTypeByCode(props.row['invoiceSettlementStatus']).text"
                                     :color="getSettlementTypeByCode(props.row['invoiceSettlementStatus']).color"
                                     text-color="#7c8171"
                      />
                    </span>
                    <span v-else>
                      {{ col.value }}
                    </span>
                  </q-td>
                  <q-td class="width-1 text-center nowrap" auto-width>
                    <span class="buttons-row">
                      <span :key="0" class="btDetalhar">
                        <q-btn flat small class="btAlterar-btn protocol-close" color="primary"
                               @click="actionButtonDetail(props.row)">
                          <q-icon name="visibility" size="22px" />
                          <q-tooltip>
                            {{ $gettext("DETAIL") }}
                          </q-tooltip>
                        </q-btn>
                      </span>
                    </span>
                  </q-td>
                </q-tr>
              </template>

            </jt-data-table>
          </q-card-section>

        </q-card>
      </div>
    </div>
    <confirmation-modal
      :visible="showApprovalModal"
      mode="approve"
      @approve="approve"
      @close="showApprovalModal = false"
    />

    <confirmation-modal
      :visible="showRejectModal"
      mode="deny"
      @deny="deny"
      @close="showRejectModal = false"
    />
    <modal
      v-if="modalFilter.show"
      ref="filterModal"
      :show="modalFilter.show"
      :forms="modalFilter.forms"
      :label="this.$gettext('FILTER')"
      @action-button="actionButtonFilter"
      @input="
        function hideModal() {
          modalFilter.show = false;
        }
      "
    />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtCrud, JtDynamicForm } from 'jtech-webcomps'
import AnalyzeInvoiceSettlementController from './AnalyzeInvoiceSettlementController'
import MainContentLayout from '../service-request/view/Layout/MainContentLayout.vue'
import BlockHeader from '../service-request/view/financial/invoice/component/serviceRequestInvoice/BlockHeader.vue'
import AnalyzeInvoiceSettlementTableHeader from './components/AnalyzeInvoiceSettlementTableHeader.vue'
import ButtonFilter from './components/ButtonFilter.vue'
import { settlementTypeMap } from './components/settlementTypeMap.js'
import InfoBoxPanel from './components/InfoBoxPanel.vue'
import InfoBoxPanelField from './components/InfoBoxPanelField.vue'
import AnalyzeInvoiceSettlementDetail from './AnalyzeInvoiceSettlementDetail.vue'
import { QCheckbox, QTd } from 'quasar'
import ConfirmationModal from './components/ConfirmationModal.vue'
import ServiceRequestInvoiceSettlementDatable
  from '../service-request/view/financial/invoice/invoice-settlement/ServiceRequestInvoiceSettlementDatatable.vue'
const { modal } = JtCrud
import { invoiceSettlementStatus } from 'src/shared/inf-tabela-descricao/InvoiceSettlementStatus.enum.js'

const createErrorMessages = (vm) => ({
  LOAD_ERROR: vm.$gettext('ERROR_LOADING_DATA'),
  LOAD_DATATABLE_ERROR: vm.$gettext('ERROR_LOADING_DATATABLE'),
  LOAD_DATATABLE_MODEL_ERROR: vm.$gettext('ERROR_LOADING_DATATABLE_MODEL'),
  ACTION_ERROR: vm.$gettext('ERROR_EXECUTING_ACTION'),
  DETAIL_ERROR: vm.$gettext('ERROR_DETAIL_RECORD')
})

@Component({
  name: 'AnalyzeInvoiceSettlementTable',
  components: {
    ServiceRequestInvoiceSettlementDatable,
    QCheckbox,
    QTd,
    JtDataTable,
    MainContentLayout,
    BlockHeader,
    AnalyzeInvoiceSettlementTableHeader,
    ButtonFilter,
    InfoBoxPanel,
    InfoBoxPanelField,
    modal,
    ConfirmationModal,
    JtDynamicForm
  },
  props: {
    name: String,
    params: { type: Object, required: true },
    datatable: { type: Object, required: true },
    forms: { type: Array, required: true },
    selected: Object,
    key: Object
  }
})

class AnalyzeInvoiceSettlementTable extends Vue {
  analyzeInvoiceSettlementController = AnalyzeInvoiceSettlementController.getInstance();

  totalInvoiceSettlement = 0
  showApprovalModal = false
  showRejectModal = false
  showModal = false
  selectedIds = []
  forms = null
  data = null;
  datatable = null;
  datatableModel = [];
  dataAuxFilter = [];
  modalFilter = {
    show: false,
    forms: [],
    initialForm: []
  };

  displayedSettlementType = [
    'ALL',
    'EXEMPTION',
    'UPDATE_UNIT'
  ]

  ERROR_MESSAGES = null;

  allSelected = false;

  async actionButtonFilter (button, params) {
    this.analyzeInvoiceSettlementController.setSearchParams(params)
    const records = await this.analyzeInvoiceSettlementController.searchWithFilters(params)
    this.data = (records || []).map(row => ({
      ...row,
      selected: false
    }))
    this.dataAuxFilter = this.data
    this.modalFilter.show = false
    this.resetSelection()
  }

  created () {
    this.ERROR_MESSAGES = createErrorMessages(this)
    if (this.data) {
      this.data = this.data.map(row => ({
        ...row,
        selected: false
      }))
    }
  }

  get invoiceSettlementStatus () {
    return invoiceSettlementStatus()
  }

  get isAnyItemSelected () {
    if (this.data == null) {
      return false
    }
    const dataSelected = this.data.filter(row => this.selectedIds.includes(row.id) && row.invoiceSettlementStatus != this.invoiceSettlementStatus.PENDING.key)
    return this.selectedIds.length > 0 && dataSelected && dataSelected.length == 0
  }

  async deny (observation) {
    const _self = this
    if (this.isAnyItemSelected) {
      try {
        const denialPromises = this.selectedIds.map(async (id) => {
          await this.analyzeInvoiceSettlementController.deny({ id: id, observation: observation })
          return id
        })

        const deniedIds = await Promise.all(denialPromises)

        this.$q.loading.hide()
        await _self.updateTable()
        await _self.loadDatatableModel()
        this.allSelected = false
      } catch (error) {
        this.$q.loading.hide()
        this.$q.notify({
          type: 'negative',
          message: this.$gettext('DENIAL_FAILED')
        })
      }
    } else {
      this.$q.notify({
        type: 'negative',
        message: this.$gettext('NO_ITEM_SELECTED')
      })
    }
  }

  async approve () {
    const _self = this
    if (this.isAnyItemSelected) {
      this.$q.loading.show({
        message: this.$gettext('APPROVING_ITEMS')
      })

      try {
        const approvalPromises = this.selectedIds.map(async (id) => {
          const response = await this.analyzeInvoiceSettlementController.approve(id)
          return id
        })

        const approvedIds = await Promise.all(approvalPromises)
        this.allSelected = false
        this.$q.loading.hide()
        await _self.updateTable()
        await _self.loadDatatableModel()
      } catch (error) {
        this.$q.loading.hide()
        this.$q.notify({
          type: 'negative',
          message: this.$gettext('APPROVAL_FAILED') + (error.message ? `: ${error.message}` : '')
        })
      }
    } else {
      this.$q.notify({
        type: 'negative',
        message: this.$gettext('NO_ITEM_SELECTED')
      })
    }
  }

  updateSelection (row, status) {
    if (status) {
      this.selectedIds.push(row.id)
    } else {
      const index = this.selectedIds.indexOf(row.id)
      if (index > -1) {
        this.selectedIds.splice(index, 1)
      }
    }
  }

  async actionButtonDetail (row) {
    const datatable = await this.analyzeInvoiceSettlementController.loadDetail(row.id)

    this.params.crudLayout.addPage({
      label: this.$gettext('MANAGER_RELEASE'),
      forms: datatable,
      params: { params: this.params },
      component: AnalyzeInvoiceSettlementDetail,
      flClose: true
    })
  }

  async mounted () {
    try {
      await Promise.all([
        this.load(),
        this.loadData(),
        this.loadDatatableModel(),
        this.updateTable()
      ])
      this.resetSelection()
    } catch (error) {
      this.$q.notify({
        type: 'negative',
        message: error.message
      })
    }
  }

  async load () {
    try {
      await this.analyzeInvoiceSettlementController.loadInvoices()
    } catch (error) {
      this.$q.notify({
        type: 'negative',
        message: error.message
      })
    }
  }

  async loadData () {
    try {
      this.datatable = await this.analyzeInvoiceSettlementController.loadDatatable()
    } catch (error) {
      this.$q.notify({
        type: 'negative',
        message: error.message
      })
    }
  }

  async loadDatatableModel () {
    try {
      this.datatableModel = await this.analyzeInvoiceSettlementController.loadDatatableModel(this.analyzeInvoiceSettlementController.state.searchParams)
      if (this.datatableModel) {
        this.datatableModel = this.datatableModel.map(row => ({
          ...row,
          selected: false
        }))
        this.totalInvoiceSettlement = this.datatableModel.length
        this.dataAuxFilter = this.datatableModel
        this.data = this.datatableModel
      }
    } catch (error) {
      this.$q.notify({
        type: 'negative',
        message: error.message
      })
    }
  }

  resetSelection () {
    this.allSelected = false
    this.selectedIds = []
    if (this.data) {
      this.data.forEach(row => {
        row.selected = false
      })
    }
  }

  get nmInterface () {
    return this.interface
  }

  get page () {
    return AnalyzeInvoiceSettlementTable
  }

  get settlementType () {
    return settlementTypeMap()
  }

  getSettlementTypeByCode (code) {
    if (code) {
      for (const settlement in this.settlementType) {
        if (
          Object.prototype.hasOwnProperty.call(this.settlementType, settlement)
        ) {
          const settlementKeys = this.settlementType[settlement].keys || []
          if (settlementKeys.includes(code)) {
            return this.settlementType[settlement]
          }
        }
      }
    }
    return { text: code, color: '#fff' }
  }

  async updateTable () {
    const records = await this.analyzeInvoiceSettlementController.loadDatatableModel(this.analyzeInvoiceSettlementController.state.searchParams)
    this.data = (records || []).map(row => ({
      ...row,
      selected: false
    }))
    this.dataAuxFilter = this.data
  }

  async openModalFilter () {
    this.modalFilter.forms = await this.analyzeInvoiceSettlementController.formFilter()
    this.modalFilter.initialForm = this.modalFilter.forms
    this.modalFilter.show = true
  }

  filterInvoice (text) {
    if (text === 'ALL') {
      this.data = this.dataAuxFilter.map(row => ({
        ...row,
        selected: this.selectedIds.includes(row.id)
      }))
    } else {
      const settlementTypeData = this.settlementType[text]
      if (settlementTypeData && settlementTypeData.keys) {
        this.data = this.dataAuxFilter
          .filter((invoice) => settlementTypeData.keys.includes(invoice.invoiceSettlementType))
          .map(row => ({
            ...row,
            selected: this.selectedIds.includes(row.id)
          }))
      }
    }
  }
}

export default AnalyzeInvoiceSettlementTable

</script>

<style scoped>
@import "tailwindcss/utilities";

.table-header {
  position: fixed;
  top: 0;
  z-index: 10;
}

.color-gray {
  color: #333
}

.reproval {
  background-color: #e25959;
  color:#fff;
  border: 0px
}

.approval {
  background-color: #00c79e;
  color:#fff;
  border: 0px
}

.filter {
  background-color: #fff;
  color: #555;
  border: 1px solid #ddd;
  border-radius: 4px;

  &:hover {
    background-color: #f5f5f5;
  }
}

.width-1 {
  width: 1px
}

.nowrap {
  white-space: nowrap
}
</style>
